import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";
import { InfoCircleFill } from "react-bootstrap-icons";

export default function ComparisonSongsHeader({ sortConfig, requestSort, showFirstOn = false }) {
    return (
        <Container fluid className="sticky-top">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100 pe-xl-3">
                <Col onClick={() => requestSort("artist")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col onClick={() => requestSort("title")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} onClick={requestSort ? () => requestSort("release_year") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Release Year</span>
                        <span className="col-1">{renderSortIcon("release_year", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1">Spins</span>
                        <span className="col-1">{renderSortIcon("spins", sortConfig)}</span>
                    </Stack>
                </Col>
                {showFirstOn && (
                    <>
                        <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("radio_spin[0].spins") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1">Spins A</span>
                                <span className="col-1">{renderSortIcon("radio_spin[0].spins", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("radio_spin[1].spins") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1">Spins B</span>
                                <span className="col-1">{renderSortIcon("radio_spin[1].spins", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col xs={2} xl={2} onClick={requestSort ? () => requestSort("first_on") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center text-center">
                                <span className="offset-1 text-center">First on</span>
                                <span className="col-1">{renderSortIcon("first_on", sortConfig)}</span>
                            </Stack>
                        </Col>
                    </>
                )}

                <Col xs={"auto"} style={{ width: 44 }} className=" d-none d-xl-block">
                    <InfoCircleFill className="invisible" />
                </Col>
            </Row>
        </Container>
    );
}
